import { useState } from "react";
import { Link } from "react-router-dom";
import { MailCheck, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Reveal } from "./Reveal";

export const Newsletter = () => {
    const [email, setEmail] = useState("");
    const [consenso, setConsenso] = useState(false);
    const [sending, setSending] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setSending(true);
        const data = new FormData(e.target);
        data.append("form-name", "newsletter");
        try {
            const res = await fetch("/", {
                method: "POST",
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                body: new URLSearchParams(data).toString(),
            });
            if (!res.ok) throw new Error("send failed");
            toast.success("Iscrizione confermata. Grazie per la fiducia.");
            setEmail("");
            setConsenso(false);
        } catch {
            toast.error("Non è stato possibile completare l'iscrizione. Riprova tra poco.");
        } finally {
            setSending(false);
        }
    };

    return (
        <section id="newsletter" className="bg-cream border-t border-ink/5" data-testid="newsletter-section">
            <div className="max-w-3xl mx-auto px-6 sm:px-12 py-16 md:py-24 text-center">
                <Reveal>
                    <span className="inline-flex items-center justify-center rounded-full bg-sage-light p-4 text-sage-dark mb-6">
                        <MailCheck size={26} strokeWidth={1.6} />
                    </span>
                    <h2 className="font-serif text-3xl sm:text-4xl leading-snug text-ink" data-testid="newsletter-title">
                        Restiamo in contatto
                    </h2>
                    <p className="mt-5 text-base sm:text-lg text-[#526063] leading-relaxed max-w-xl mx-auto">
                        Riflessioni e spunti su psicologia, emozioni e consapevolezza, direttamente nella tua casella. Solo contenuti utili, senza frequenza ossessiva.
                    </p>
                </Reveal>
                <Reveal delay={0.1}>
                    <form
                        name="newsletter"
                        method="POST"
                        data-netlify="true"
                        netlify-honeypot="bot-field"
                        onSubmit={submit}
                        className="mt-9"
                        data-testid="newsletter-form"
                    >
                        <input type="hidden" name="form-name" value="newsletter" />
                        <p className="hidden" aria-hidden="true">
                            <label>Non compilare questo campo: <input name="bot-field" tabIndex={-1} autoComplete="off" /></label>
                        </p>
                        <div className="flex flex-col sm:flex-row gap-3 max-w-lg mx-auto">
                            <input
                                type="email"
                                name="email"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="La tua email"
                                aria-label="Indirizzo email per la newsletter"
                                className="flex-1 rounded-full border border-ink/15 bg-white px-6 py-4 text-base text-ink placeholder:text-ink/35 focus:outline-none focus:ring-2 focus:ring-sage/50 focus:border-sage transition-all duration-300"
                                data-testid="newsletter-input-email"
                            />
                            <button
                                type="submit"
                                disabled={sending}
                                data-testid="newsletter-submit-btn"
                                className="inline-flex items-center justify-center gap-2 rounded-full bg-petrol text-cream px-8 py-4 text-base font-semibold hover:bg-petrol-soft hover:shadow-lg transition-all duration-300 disabled:opacity-60"
                            >
                                {sending && <Loader2 size={18} className="animate-spin" />}
                                {sending ? "Iscrizione..." : "Iscriviti"}
                            </button>
                        </div>
                        <label className="mt-5 flex items-start sm:items-center justify-center gap-3 text-left text-xs text-[#7A8C8E] max-w-lg mx-auto cursor-pointer" data-testid="newsletter-consent-label">
                            <input
                                type="checkbox"
                                name="consenso"
                                value="si"
                                required
                                checked={consenso}
                                onChange={(e) => setConsenso(e.target.checked)}
                                className="mt-0.5 sm:mt-0 h-4 w-4 shrink-0 accent-[#2A474E]"
                                data-testid="newsletter-consent-checkbox"
                            />
                            <span>
                                Ho letto la <Link to="/privacy-policy" className="underline underline-offset-2 text-petrol">Privacy Policy</Link> e acconsento al trattamento della mia email per ricevere la newsletter. Potrai cancellarti in qualsiasi momento.
                            </span>
                        </label>
                    </form>
                </Reveal>
            </div>
        </section>
    );
};
